import React from 'react'
import classNames from 'classnames'

import { connect } from 'react-redux'
import { Link } from 'react-router'

import GirlList from './girllist.react.js'
import {begin_load_girls, load_girls, load_girls_schedule, set_shop_fav, get_shop_memo, set_shop_memo} from '../actions'
import {LoginOrRegister} from './loginorregister.react.js'
import {MemoForm} from './memo.react.js'

const shopInfoMapStateToProps = (state) => {
  return {
  }
}

const shopInfoMapDispatchToProps = {
  begin_load_girls, load_girls, load_girls_schedule, set_shop_fav, get_shop_memo, set_shop_memo
}

const ShopInfo = connect(shopInfoMapStateToProps, shopInfoMapDispatchToProps)(React.createClass({
  getInitialState: function() {
    return {
      girllist:this.props.girllist ? this.props.girllist : 'hidden',
      showLoginOrRegister: false,
      formCaption: '',
      showMemo: false
    }
  },

  showSchedule: function(e) {
    if (this.state.girllist != 'schedule') {
      this.props.begin_load_girls(this.props.shop)
      this.setState({girllist:'schedule'})
      this.props.load_girls_schedule(this.props.shop).then((ret)=>{
//        this.setState({girllist:'schedule'})
      })
    }
    else {
      this.setState({girllist:'hidden'})
    }
  },

  showGirls: function(e) {
    if (this.state.girllist != 'all') {
      this.props.begin_load_girls(this.props.shop)
      this.setState({girllist:'all'})
      this.props.load_girls(this.props.shop).then((ret)=>{
//        this.setState({girllist:'all'})
      })
    }
    else {
      this.setState({girllist:'hidden'})
    }
  },

  toggleShopFav: function(e) {
    e.preventDefault()
    if (window.show_user) {
      this.props.set_shop_fav(this.props.shop, !this.props.shop.fav);
    }
    else {
      this.setState({
        showLoginOrRegister: true,
        formCaption: 'オキニ登録にはユーザ登録が必要です'
      })
    }
  },

  showMemo(e) {
    e.preventDefault()

    if (window.show_user) {
      this.props.get_shop_memo(this.props.shop)
        .then(ret=>{
          this.setState({showMemo: true})
        })
    }
    else {
      this.setState({
        showLoginOrRegister: true,
        formCaption: 'メモ登録にはユーザ登録が必要です'
      })
    }
  },

  closeForm(e) {
    this.setState({
      showLoginOrRegister: false,
    })
  },

  closeMemo(e) {
    this.setState({showMemo: false})
  },

  saveMemo(memo) {
    return this.props.set_shop_memo(this.props.shop, memo)
  },

  render: function() {
    const shop = this.props.shop;
    var schedule_button = this.state.girllist == 'schedule' ? '閉じる' : '出勤予定'
    var girls_button = this.state.girllist == 'all' ? '閉じる' : '在籍一覧'

    var girlsbutton = null;
    if (shop.slug) {
      girlsbutton = (
        <span>
          <button type="button" className="btn btn-default btn-xs schedule-today"
            onClick={this.showSchedule}>{schedule_button}</button>
          &nbsp;
          <button type="button" className="btn btn-default btn-xs girl-list"
            onClick={this.showGirls}>{girls_button}</button>
        </span>

      )
    }

    var girllist = this.state.girllist == 'hidden' ? null : <GirlList shop={shop}/>
    var aa = null
    if (shop.a) {
      aa = <a target='_blank' href={shop.a}>---</a>
    }

    const captions = (<p>{shop.caption.split('\n').map((L, i)=>(<span key={i}>{L}<br/></span>))}</p>)

    return (
      <div className='shop-panel'>
        <LoginOrRegister showModal={this.state.showLoginOrRegister} formCaption={this.state.formCaption}
          close={this.closeForm}/>
        <MemoForm shop={shop} memo={shop.memotext} showModal={this.state.showMemo} close={this.closeMemo}
          save_memo={this.saveMemo}
          title={"お店メモ"}/>

        <div className='panel panel-default shop-list-item'>
          <div className='panel-heading clearfix'>
            <a className={classNames('shop-favbutton', 'fa' , {'fa-heart': shop.fav, 'fa-heart-o': !shop.fav})}
              title='お気に入りに登録' href='#'
              onClick={this.toggleShopFav}>
              <span className='okini-button'> オキニ </span>
            </a>

            <h1 className='shop-name'>
              <Link to={{pathname:"/shop", query:{shopid:shop.id}}}>
                {shop.name}
              </Link>
            </h1>

            <a className={classNames('shop-memobutton', 'fa' , 'fa-edit', {'usermemo': shop.memo})}
              title='メモ'
              href='#' onClick={this.showMemo}>
                <span className="memo-button">メモ</span>
            </a>
            &nbsp;
            <a href={shop.url} target='_blank'>
              <span className='fa fa-home'>公式ページ</span>
            </a>

            <div className='shop-name-buttons'>
              <span className='label label-danger'>{shop.category}</span>
              &nbsp;
              <span className='label label-danger'>{shop.style}</span>
            </div>
          </div>

          <div style={{display:'inline-block', width:'100%'}}>
            <div className='clearfix'>
            <p className='shop-thumbnail'>
              <Link to={{pathname:"/shop", query:{shopid:shop.id}}}>
                <img className='shop-thumbnail' src={'/static/screenshots/screen_'+shop.id+'.jpg'}/>
              </Link>
            </p>
            <div className='shopdesc'> {captions} {aa}</div>
            </div>

            <p className='shop-detail'>
              <span className='label label-default'>TEL</span> <a href={'tel://'+shop.tel}>{shop.tel}</a> &nbsp;
              <span className='label label-default'>住所</span> <a target='_blank' href={'https://www.google.co.jp/maps/place/'+shop.addr}>{shop.addr}</a>
            </p>

            <div className='panel-footer shop-menu-bar' style={{verticalAlign:'bottom'}}>
              {girlsbutton}
            </div>
          </div>
          {girllist}
        </div>
      </div>
    )
  }
}))

export default ShopInfo



// WEBPACK FOOTER //
// ./components/shopinfo.react.js